import { serviceConsumer } from "../network/ServiceConsumer";

// Payer side of admin payment requests (card 1bda37b5). The backend answers a
// request that isn't this user's with 200 { forOtherAccount: true } (never a
// 401/403, which the global interceptor treats as a logout).
const BASE = process.env.REACT_APP_BASE_URL;

export const getRequest = (id) => serviceConsumer("GET", `${BASE}/payment-requests/${id}`);
export const payRequest = (id) => serviceConsumer("POST", `${BASE}/payment-requests/${id}/pay`, {});
